import React from 'react';
import { Box } from '@amzn/awsui-components-react';
import Wizard, { WizardProps } from '@amzn/awsui-components-react/polaris/wizard';
import { NonCancelableEventHandler } from '@amzn/awsui-components-react/polaris/internal/events';
import { useWizardStrings } from '../../../hooks/localization/wizardStrings';
import { publishKatalMetric } from '../../katalAnalytics';

export const FIRST_PAGE = 0;

type WizardStepProps = {
  title: string;
  content: JSX.Element;
}[];

export interface CreateEventWizardProps extends Partial<WizardProps> {
  steps: WizardStepProps;
  onCancel: NonCancelableEventHandler;
  onSubmit: NonCancelableEventHandler;
  activeStepIndex: number;
  stepError?: React.ReactNode;
  metricPrefix: string;
  eventId?: string;
  submitMetricName?: string;
}

export function CreateEventWizard({
  stepError,
  metricPrefix,
  eventId = '',
  submitMetricName,
  ...props
}: CreateEventWizardProps) {
  const namespaces = ['events', 'translation'];
  const wizardStrings = useWizardStrings('createEventWizard', namespaces);

  const steps = stepError
    ? props.steps.map((step) => ({
        ...step,
        content: (
          <>
            {step.content}
            <Box margin={{ top: 'm' }}>{stepError}</Box>
          </>
        ),
      }))
    : props.steps;

  return (
    <Wizard
      i18nStrings={wizardStrings}
      {...props}
      onCancel={(input) => {
        publishKatalMetric(`${metricPrefix}_cancelWizard`, eventId);
        props.onCancel(input);
      }}
      onNavigate={(event) => {
        publishKatalMetric(`${metricPrefix}_wizardPage`, `${event.detail.requestedStepIndex}`);
        if (props.onNavigate) {
          props.onNavigate(event);
        }
      }}
      steps={steps}
      onSubmit={(input) => {
        publishKatalMetric(submitMetricName ?? `${metricPrefix}_submit`, eventId);
        props.onSubmit(input);
      }}
      activeStepIndex={props.activeStepIndex}
      secondaryActions={props.secondaryActions}
    />
  );
}
